export const apiGenderRepresentationEnum = {
    MALE: 0,
    FEMALE: 1,
    NO_GENDER: 2
}
